export const mapAvailableTermsV2toV1 = (availableTerms) => {
  const availableTermsMap = new Map();
  availableTerms.forEach(({ field, results }) => {
    // TODO: rdar://124631848 code clean up
    if(field === "classifier_text_general") {
      let resultTokens = new Set();
      Object.keys(results).forEach((result) => {
        if(result) {
          const possibleTokens = result.split(",").map(token => token.trim());
          resultTokens = new Set([...resultTokens, ...possibleTokens]);
        }
      });
      availableTermsMap.set(field, Array.from(resultTokens).map((result) => ({ key: result, displayName: result })));
    } else {
      availableTermsMap.set(field, Object.keys(results).map((result) => ({ key: result, displayName: result })));
    }
  });
  return Object.fromEntries(availableTermsMap);
}